import * as React from 'react'
import { IconWithText } from '@components/icon-with-text'
import { Icon } from '@components/icon'
import { SubscriptionWithBenefitCodeInput } from '@modules/aside/subscription-with-benefits/subscription-with-benefit-code-input'
import { CustomTooltip } from '@components/custom-tooltip'
import { GLOBAL_URLS } from '@helpers/consts'

export const SubscriptionWithBenefitsCodeBanner = (): JSX.Element => (
  <div className="subscription-with-benefits__banner card mt-3 px-4 pe-4 text-darker-gray">
    <strong className="subscription-with-benefits__banner__title">Oferty specjalne</strong>

    <SubscriptionWithBenefitCodeInput />
    <CustomTooltip delay={500} id="subscription-with-benefits-code" content={<TooltipContent />}>
      <IconWithText
        text="Jak skorzystać ze specjalnych lokali?"
        iconClassName="uil-exclamation-circle text-primary me-1 lh-0"
        textClassName="fw-semi-bold font-size-md text-start lh-0"
        wrapperClassName="mt-3 cursor-default"
      />
    </CustomTooltip>
    <Icon icon="tag" className="subscription-with-benefits__banner__watermark" />
  </div>
)

const TooltipContent = () => (
  <p className="mt-3">
    Jesteś zainteresowany ofertami?{' '}
    <a
      href={GLOBAL_URLS.ECOMMERCE}
      target="_blank"
      className="text-decoration-none text-nowrap fw-semi-bold text-primary me-2"
    >
      Zobacz w E-Sklepie
    </a>
    lub zadzwoń: 696 11 67 67
  </p>
)
